import React, { Suspense } from "react";
import ReactDOM from "react-dom";

// import "./fonts/DBHeavent.woff";
// import "./fonts/DBHeavent.woff2";
// import "./fonts/DBHeavent-Med.woff";
// import "./fonts/DBHeavent-Med.woff2";
// import "./fonts/DBHeavent-Thin.woff";
// import "./fonts/DBHeavent-Thin.woff2";
// import "./fonts/DBHeavent-Cond.woff";
// import "./fonts/DBHeavent-Cond.woff2";
// import "./fonts/DBHeavent-Bold.woff";
// import "./fonts/DBHeavent-Bold.woff2";
// import "./fonts/DBHeaventt-Light.woff";
// import "./fonts/DBHeaventt-Light.woff2";

// import "./index.css";
// import "./style/styles.scss";

// import reportWebVitals from "./reportWebVitals";
import allReducers from "./reducers";
import { createStore } from "redux";
import { Provider } from "react-redux";

import "./i18n";
import LoadingComponent from "./component/LoadingComponent";

import App from "./App";
// const App = React.lazy(() => import("./App"));

// let store = createStore(allReducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
const store = createStore(allReducers);

ReactDOM.render(
    <Suspense fallback={<LoadingComponent />}>
        <Provider store={store}>
            <App />
        </Provider>
    </Suspense>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();j
